function UserAgentFilter (uaparser) {
  function filter (value) {
    if (!value) {
      return '-'
    }

    // Operations performed through the admin MCP surface record the user agent
    // "easytick-mcp" (feature 018+); ua-parser cannot parse it and renders the
    // literal "undefined". Prefix match tolerates a future versioned UA
    // (e.g. "easytick-mcp/1.1"). Applies retroactively to already-stored rows.
    if (value.indexOf('easytick-mcp') === 0) {
      return 'MCP'
    }

    const p = new uaparser.UAParser()
    p.setUA(value)
    const browser = p.getBrowser()

    let out = browser.name
    out += browser.major !== undefined ? ' ' + browser.major : ''

    const device = p.getDevice()
    out += device.vendor !== undefined ? device.vendor : ''

    const os = p.getOS()
    out += os.name !== undefined ? ' no ' + os.name : ''
    out += os.version !== undefined ? ' ' + os.version : ''

    return out
  }

  return {
    filter
  }
}

export default UserAgentFilter
